import Editor from "../components/editor";
import henceforthApi from "../utils/henceforthApi";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useContext, useState ,useNavigte} from "react";
import { GlobalContext } from "../context/Provider";
import { ChipButton } from "../components/BootstrapCompo";
import Spinner from "../components/spinnerRound";

const  Notification=()=> {
  const { authState } = useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);
  const [description, setDesciption] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [subject, setSubject] = useState("");
  const[loading ,setLoading]=useState(false)
  const [state, setState] = useState({
    type: "EMAIL",
    send_to: "ALL_USERS",
    user_ids: [] ,
    list_user: [],
    users: [],
    selectedUser: new Map(),
  });

  const radioHandler = (send_to) => {
    if (send_to === "ALL_USERS") {
      // Clear email input, users list, and selected users when switching to All Users
      setInputValue("");
      setState({
        ...state,
        send_to,
        users: [],
        list_user: [],
        user_ids: [],
        selectedUser: new Map(),
      });
    } else {
      setState({
        ...state,
        send_to,
      });
    }
  };
  const radioHandlerType = (type) => {
    setState({
      ...state,
      type,
    });
  };

// const arrayLength= 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (state.send_to === "SELECTED_USERS" && !state.user_ids.length) return toast.warn('please add atleast one user')
    if (!subject) {
      return toast.warn("Please enter subject");
    }
    const remove_space = description.replace(/\s/g, "")
    if (description === '<p><br></p>' || remove_space === '<p></p>') return toast.warn('Please enter a valid text in description')
    if (!description.trim()) return toast.warn('Please enter a valid text in description')
    const items = {
      type: state.type == "EMAIL"? 1:2,
      send_to: state.send_to == "ALL_USERS" ? 1:2,
      user_ids: state.user_ids,
      subject: subject,
      message: description,
      language: "ENGLISH",
    };
    setLoading(true)
    try {
      const res = await henceforthApi.Administrator.sendNotifications(items)
      // console.log(res)
      Swal.fire({
        title: "Notification Sent",
        text: "successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
      setDesciption("");
      setSubject("");
      setState({
        ...state,
        user_ids: state.user_ids,
        list_user: [],
      });
      setLoading(false)
      // console.log(state);
    } catch (error) {

      Swal.fire({
        title: "Error!",
        text: error.response.body.error_description,
        icon: "error",
        confirmButtonText: "Cancel",
      });
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  const handleFIlter = async (value) => {
    setInputValue(value);
    if (value) {
      setLoading(true)
      try {
        let apiRes = await henceforthApi.Common.allUsers(value);
        setState({
          ...state,
          users: apiRes.users,
        });
        setLoading(false);
      } catch (error) {
        setState({
          ...state,
          users: [],
        });
        setLoading(false);
      }
    }
  };

  const onClickChip = (_id, name) => {
    const { selectedUser } = state;
    if (selectedUser.has(_id)) {
      selectedUser.delete(_id);
    } else {
      selectedUser.set(_id, name);
    }
    let rowDataId = [] 
    let rowData = [] ;
    selectedUser.forEach((res, key) => {
      // console.log(res, key);
      rowDataId.push(key);
      rowData.push({ _id: key, name: res });
    });
    setState({
      ...state,
      list_user: rowData,
      selectedUser,
      user_ids: rowDataId,
      users: [],
    });
    setInputValue("");
  };
  return (
    <>
      {/* notification */}
      <div className="row animated fadeInRight">
        {/* header */}
        <div className="row">
          <div className="col-md-12 p-0">
          </div>
        </div>
        {/* notification-content */}
        <div className="row">
          <div className="col-md-12">
            <div className="main-box">
              <div className="notification-box">
                {/* notification-header */}
                <div className="notification-header py-3 px-4">
                  <h6>Notification</h6>
                </div>
                {/* notification-content */}
                <form onSubmit={handleSubmit} className="notification-content pt-0 p-4">
                  {/* Select users by Email */}
                  <div className="row mb-2">
                  <div className="col-md-12">
                      <h6>Select users by Email</h6>
                    </div>
                    <div className="col-md-12">
                      <ul
                        className="nav nav-pills gap-3 gap-md-5"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation" onClick={(e) => radioHandler("ALL_USERS")}>
                          <div className="form-check d-flex align-items-center gap-2">
                            <input
                              className="form-check-input shadow-none my-0"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-All"
                              required
                              checked={state.send_to === "ALL_USERS"}
                            />
                            <label className="form-check-label align-sup" htmlFor="flexRadioDefault1">
                              All Users
                            </label>
                          </div>
                        </li>
                        <li className="nav-item" role="presentation" onClick={(e) => radioHandler("SELECTED_USERS")}>
                          <div className="form-check d-flex align-items-center gap-2">
                            <input
                              className="form-check-input shadow-none my-0"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault2"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-Selected"
                              required
                              checked={state.send_to === "SELECTED_USERS"}
                            />
                            <label className="form-check-label align-sup" htmlFor="flexRadioDefault2">
                              Selected Users
                            </label>
                          </div>
                        </li>
                      </ul>

                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade"
                          id="pills-Selected"
                          role="tabpanel"
                          aria-labelledby="pills-Selected-tab"
                        >
                          <>
                         {state.send_to == "SELECTED_USERS" ?   <div>
                              <label className="form-label mb-2">
                                Email address
                              </label>
                              <input
                                type="email"
                                className="form-control shadow-none"
                                id="exampleFormControlInput1"
                                placeholder="Select user by Email"
                                value={inputValue}
                                onChange={(e) => handleFIlter(e.target.value)}
                              />
                              <ul className="list-group">
                                {state?.users?.filter((resp) => !state.user_ids.includes(resp._id)).map((res) =>
                                  <li
                                    className="list-group-item"
                                    role="button"
                                    onClick={() =>
                                      onClickChip(res._id, `${res.email}`)
                                    }
                                  >
                                    {res.email}{" "}
                                  </li>
                                )}
                              </ul>
                            </div>  : ""}
                            {state.send_to === "SELECTED_USERS" && state.list_user.length ? (
                              <>
                                <div className="form-group">
                                  <label className="mb-2">Selected User</label>
                                  <div className=" d-flex ">
                                    {state.list_user.map((res) => {
                                      return (
                                        <ChipButton
                                          key={res._id}
                                          {...res}
                                          onClick={onClickChip}
                                        />
                                      );
                                    })}
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </>



                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Select users by Phone Number */}
                  {/* <div className="row mb-2">
                    <div className="col-md-12 mb-2">
                      <h6>Select users by Phone Number</h6>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex gap-3 gap-lg-5 flex-wrap">
                        <div className="form-check d-flex align-items-center gap-2">
                          <input
                            className="form-check-input shadow-none my-0"
                            type="radio"
                            name="flexRadioDefault-2"
                            id="flexRadioDefault3"
                            checked
                          />
                          <label className="form-check-label align-sup" htmlFor="flexRadioDefault3">
                            All Users
                          </label>
                        </div>
                        <div className="form-check d-flex align-items-center gap-2">
                          <input
                            className="form-check-input shadow-none my-0"
                            type="radio"
                            name="flexRadioDefault-2"
                            id="flexRadioDefault4"
                          />
                          <label className="form-check-label" htmlFor="flexRadioDefault4">
                            Only Selected Users
                          </label>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* Subject */}
                  <div className='row mb-2'>
                    <div className="col-md-12">
                      <label className="form-label mb-2">
                        <h6>Subject</h6>
                      </label>
                      <input
                        type="text"
                        className="form-control shadow-none"
                        id="exampleFormControlInput2"
                        placeholder="Write your subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* Select users by type*/}
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <h6>Select users by type</h6>
                    </div>
                    {/* Select users by type*/}
                    <div className="col-md-12">
                      <div className="user-type d-flex gap-3 gap-lg-5 flex-wrap mt-2">
                        <div className="form-check d-flex align-items-center gap-2" onClick={(e) => { setDesciption(''); radioHandlerType("EMAIL") }}>
                          <input
                            className="form-check-input shadow-none my-0"
                            type="radio"
                            name="flexRadioDefault-3"
                            id="flexRadioDefault5"
                            checked={state.type === "EMAIL"}
                          />
                          <label className="form-check-label align-sup" htmlFor="flexRadioDefault5">
                            Email
                          </label>
                        </div>
                        {/* <div className="form-check d-flex align-items-center gap-2" onClick={(e) => radioHandlerType("PHONE")} >
                          <input
                            className="form-check-input shadow-none my-0"
                            type="radio"
                            name="flexRadioDefault-3"
                            id="flexRadioDefault6"
                            checked={state.type === "PHONE"}
                          />
                          <label className="form-check-label" htmlFor="flexRadioDefault6">Phone Number</label>
                        </div> */}
                        <div className="form-check d-flex align-items-center gap-2" onClick={(e) => { setDesciption(''); radioHandlerType("PUSH") }}>
                          <input
                            className="form-check-input shadow-none my-0"
                            type="radio"
                            name="flexRadioDefault-3"
                            id="flexRadioDefault7"
                            checked={state.type === "PUSH"}
                          />
                          <label className="form-check-label" htmlFor="flexRadioDefault7">
                            Push Notification
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* comment-box */}
                  <div className="row mb-3">
                    <div className="col-md-12 mb-5">
                      {state.type === "EMAIL" ? <Editor description={description} onEditorStateChange={setDesciption} /> : <textarea cols={5} rows={5} className={`form-control rounded-0 `} placeholder="Write your content" value={description} onChange={(e) => { setDesciption(e.target.value) }} />}
                    </div>
                  </div>
                  {/* submit-btn */}
                  <div className="row pt-5 pt-sm-2">
                    <div className="col-md-12 ">
                      <button type="submit" className="btn btn-dark px-5" disabled={loading}>
                        {loading ? <Spinner/> : 'Send'}
                      </button>
                    </div>


                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Notification;